import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import logo from '../../../img/logo.png';
import * as icons from '../Icons/Icons';

const HeaderOutside = observer(class HeaderOutside extends React.Component {
  constructor() {
    super();
    this.addSession = this.addSession.bind(this);
  }

  addSession() {
    this.props.store.ManagerStore.addSession = true;
  }

  render() {
    const { ManagerStore } = this.props.store;

    return(
      <header className="site-head site-head--outside">
        <div className='wrap--center' >
          <img className="brand" src={logo} alt="SmarterProctoring" />

          {ManagerStore.sessions.length > 0 && ManagerStore.multi &&
            <button
              className="btn btn--inverse"
              onClick={this.addSession}
            >
              <icons.iconPlus />
              Add a session
            </button>
          }
        </div>
      </header>
    );
  }
})

export default translate('HeaderOutside')(HeaderOutside);


// WEBPACK FOOTER //
// ./src/app/components/Common/HeaderOutside.js